import { ga4Event } from '@utils/analytics/ga4';

// paulinaTrack — MISMO util de telemetría que `usePaulinaChat` usa para los eventos `pau_*`
// (extraído para reusarlo desde las superficies de invitación / feedback del rollout sin
// duplicar la lógica). Manda el evento a GA4 (con params) y a Clarity (tag de sesión
// `pau_usuario` + evento SIN params — Clarity solo recibe el nombre). Sin PII. La telemetría
// NUNCA rompe la UI (try/catch silencioso).
// Convención de naming: `pau_<dominio>_<accion>` (dominio + acción en pasado).
export const paulinaTrack = (eventName: string, params: Record<string, string | number | boolean> = {}): void => {
  try {
    ga4Event(eventName, params);
    const w = window as unknown as { clarity?: (...a: unknown[]) => void };
    if (typeof w.clarity === 'function') {
      w.clarity('set', 'pau_usuario', 'true');
      w.clarity('event', eventName);
    }
  } catch {
    /* la telemetría nunca rompe la UI */
  }
};
